import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import MenuList from "@mui/material/MenuList";
import { hmLightTheme } from "../themes/hmTheme";
import CustomMenuItemLink from "../unit/CustomMenuItemLink";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import { useListContext } from "react-admin";

const AppMenuTitle = ({ ...props }) => {
  const type = props.type;
  const appCounts = props.count;
  let chipBgColor = "rgba(0, 0, 0, 0.08)";
  let textColor = "#000";

  return <Box sx={{ width: "100%" }}>{type}</Box>;
};

const RequestdataListAside = ({ ...props }) => {
  const { filterValues } = useListContext();
  const selected = filterValues?.status;
  const totalData = props.totalData;
  return (
    <>
      <HmSubHeaderTitle
        title={"Request Manual Data Changes"}
        sx={{
          display: "block",
          position: "absolute",
          top: "70px",
          left: "75px",
        }}
      />
      <Card className="hm-list-aside">
        <CardContent sx={{ pt: 0 }}>
          <MenuList component="div" id="list-campaigns-couponcode-menus">
            <CustomMenuItemLink
              to='/requestdata?filter={"status":"New"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="New" count={0} />}
              selected={selected === "New"}
              tooltipProps={{ title: "New", children: <></> }}
            />
            <CustomMenuItemLink
              to='/requestdata?filter={"status":"Responded"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="In Progress" count={0} />}
              selected={selected === "Responded"}
              tooltipProps={{ title: "In Progress", children: <></> }}
            />
            {/* Completed */}
            <CustomMenuItemLink
              to='/requestdata?filter={"status":"Completed"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Closed" count={0} />}
              selected={selected === "Completed"}
              tooltipProps={{ title: "Closed", children: <></> }}
            />
          </MenuList>
        </CardContent>
      </Card>
    </>
  );
};

export default RequestdataListAside;
